import {Unauthorized} from '../Unauthorized';
import {BaseInterface} from '../BaseInterface';

export class Factory {

    // ########################################

    public create(errors: BaseInterface[]): Unauthorized {
        return new Unauthorized(
            errors
        );
    }

    // ########################################
}
